import React from 'react'

const SvgLensIcon = props => (
  <svg className={props.className} viewBox="0 0 24 24">
    <path
      fill="#373B51"
      fillRule="evenodd"
      d="M14 7.5a1 1 0 011 1v1h2a1 1 0 011 1v5a1 1 0 01-1 1H7a1 1 0 01-1-1v-5a1 1 0 011-1h2v-1a1 1 0 011-1h4zm0 1h-4v1h4v-1z"
    />
  </svg>
)

export default SvgLensIcon
